import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "fw-bold mb-3" };
const _hoisted_2 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-lg-6 col-12" };
const _hoisted_5 = { class: "form-floating mb-3" };
const _hoisted_6 = { class: "form-floating" };
const _hoisted_7 = { class: "form-floating" };
const _hoisted_8 = { class: "form-floating" };
const _hoisted_9 = { class: "form-floating" };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "form-check mb-3" };
const _hoisted_13 = { class: "mb-3" };
const _hoisted_14 = { class: "form-check mb-3" };
const _hoisted_15 = { class: "col-lg-6 col-12" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { class: "form-floating mb-3" };
const _hoisted_18 = {
    key: 1,
    class: "form-floating mb-3"
};
const _hoisted_19 = ["value"];
const _hoisted_20 = {
    key: 2,
    class: "row"
};
const _hoisted_21 = { class: "col-12 col-lg-6" };
const _hoisted_22 = { class: "mb-3" };
const _hoisted_23 = { class: "col-12 col-lg-6" };
const _hoisted_24 = { class: "mb-3" };
const _hoisted_25 = { class: "rounded bg-white p-3" };
const _hoisted_26 = { class: "fw-bold mb-4" };
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { MultiSelect, useConfirm } from 'primevue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        iframeComponent: Object,
        externalComponentTypes: Object,
        productGalleryTypeId: String,
        productCategories: Object,
        bottles: Object,
        accessoryProducts: Object,
        availablePublicFilters: Object,
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const confirm = useConfirm();
        const editForm = useForm({
            name: props.iframeComponent ? props.iframeComponent.name : null,
            externalCssUrl: props.iframeComponent ? props.iframeComponent.externalCssUrl : null,
            externalComponentTypeId: props.iframeComponent ? props.iframeComponent.externalComponentTypeId : null,
            showFilters: props.iframeComponent ? props.iframeComponent.showFilters : false,
            publicFilters: props.iframeComponent ? props.iframeComponent.publicFilters : [],
            sliderView: props.iframeComponent ? props.iframeComponent.sliderView : false,
            externalConfiguratorUrl: props.iframeComponent ? props.iframeComponent.externalConfiguratorUrl : null,
            externalOrderSuccessUrl: props.iframeComponent ? props.iframeComponent.externalOrderSuccessUrl : null,
            externalOrderCancelUrl: props.iframeComponent ? props.iframeComponent.externalOrderCancelUrl : null,
            productGalleryContent: props.iframeComponent ? props.iframeComponent.productGalleryContent : 0,
            productCategoryUuid: props.iframeComponent ? props.iframeComponent.productCategoryUuid : null,
            bottleUuids: props.iframeComponent ? props.iframeComponent.bottleUuids : [],
            accessoryProductUuids: props.iframeComponent ? props.iframeComponent.accessoryProductUuids : []
        });
        function update() {
            if (props.iframeComponent == null) {
                return;
            }
            editForm.transform((data) => ({
                external_component_type_id: data.externalComponentTypeId,
                name: data.name,
                external_css_url: data.externalCssUrl,
                show_filters: data.showFilters ? 1 : 0,
                public_filters: data.publicFilters,
                slider_view: data.sliderView ? 1 : 0,
                external_configurator_url: data.externalConfiguratorUrl,
                external_order_success_url: data.externalOrderSuccessUrl,
                external_order_cancel_url: data.externalOrderCancelUrl,
                product_category_uuid: data.productCategoryUuid,
                bottle_uuids: data.bottleUuids,
                accessory_product_uuids: data.accessoryProductUuids,
            })).submit('put', route('admin.iFrameComponents.update', props.iframeComponent.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function remove() {
            confirm.require({
                message: 'Soll die externe Einbindung wirklich gelöscht werden?',
                header: 'Einbindung löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (props.iframeComponent == null) {
                        return;
                    }
                    router.delete(route('admin.iFrameComponents.destroy', props.iframeComponent.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Externe Einbindung" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Externe Einbindung: " + _toDisplayString(props.iframeComponent.externalEmbeddingId), 1),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("form", {
                                        onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event) => (update()), ["prevent"]))
                                    }, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editForm).name) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editForm).name]
                                            ]),
                                            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "name" }, "Name/Bezeichnung", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "externalCssUrl",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editForm).externalCssUrl) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editForm).externalCssUrl]
                                            ]),
                                            _cache[16] || (_cache[16] = _createElementVNode("label", { for: "externalCssUrl" }, "Externe CSS-URL", -1))
                                        ]),
                                        _cache[23] || (_cache[23] = _createElementVNode("p", { class: "form-text mb-3" }, "Die externe CSS-URL kann auf einem beliebigen Server liegen. Darüber kann die Gestaltung des gesamten Iframes optional definiert werden.", -1)),
                                        _createElementVNode("div", _hoisted_7, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "externalConfiguratorUrl",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editForm).externalConfiguratorUrl) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editForm).externalConfiguratorUrl]
                                            ]),
                                            _cache[17] || (_cache[17] = _createElementVNode("label", { for: "externalConfiguratorUrl" }, "Externe Konfigurator-URL", -1))
                                        ]),
                                        _cache[24] || (_cache[24] = _createElementVNode("p", { class: "form-text mb-3" }, "Die externe Konfigurator-URL zeigt auf die externe Seite, auf der der Konfigurator eingebunden ist. Hier wird beispielsweise nach einer Produktauswahl weitergeleitet.", -1)),
                                        _createElementVNode("div", _hoisted_8, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "externalOrderSuccessUrl",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editForm).externalOrderSuccessUrl) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editForm).externalOrderSuccessUrl]
                                            ]),
                                            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "externalOrderSuccessUrl" }, "Externe Erfolgs-URL nach erfolgreicher Bestellung", -1))
                                        ]),
                                        _cache[25] || (_cache[25] = _createElementVNode("p", { class: "form-text mb-3" }, "Auf diese externe URL wird nach einem erfolgreichen Zahlungsabschluss weitergeleitet.", -1)),
                                        _createElementVNode("div", _hoisted_9, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "externalOrderCancelUrl",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editForm).externalOrderCancelUrl) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editForm).externalOrderCancelUrl]
                                            ]),
                                            _cache[19] || (_cache[19] = _createElementVNode("label", { for: "externalOrderCancelUrl" }, "Externe Fehler-URL nach abgebrochener oder fehlerhafter Zahlung.", -1))
                                        ]),
                                        _cache[26] || (_cache[26] = _createElementVNode("p", { class: "form-text mb-3" }, "Auf diese externe URL wird nach einer abgebrochenen oder fehlerhaften Zahlung weitergeleitet.", -1)),
                                        _createElementVNode("div", _hoisted_10, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "externalComponentType",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editForm).externalComponentTypeId) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.externalComponentTypes, (componentType) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: componentType.id
                                                    }, _toDisplayString(componentType.name), 9, _hoisted_11));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(editForm).externalComponentTypeId]
                                            ]),
                                            _cache[20] || (_cache[20] = _createElementVNode("label", { for: "externalComponentType" }, "Typ", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "showFilters",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editForm).showFilters) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(editForm).showFilters]
                                            ]),
                                            _cache[21] || (_cache[21] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "showFilters"
                                            }, "Filter anzeigen (Flaschen, Verschlüsse, etc.)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createVNode(_unref(MultiSelect), {
                                                class: "w-100",
                                                modelValue: _unref(editForm).publicFilters,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(editForm).publicFilters) = $event)),
                                                options: props.availablePublicFilters,
                                                filter: "",
                                                optionLabel: "name",
                                                optionValue: "id",
                                                placeholder: "Öffentliche Filter"
                                            }, null, 8, ["modelValue", "options"])
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "sliderView",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(editForm).sliderView) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(editForm).sliderView]
                                            ]),
                                            _cache[22] || (_cache[22] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "sliderView"
                                            }, "Produkte als Slider anzeigen (productGallery)", -1))
                                        ]),
                                        _cache[27] || (_cache[27] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ], -1))
                                    ], 32),
                                    _createElementVNode("button", {
                                        class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                        onClick: _cache[10] || (_cache[10] = ($event) => (remove()))
                                    }, [...(_cache[28] || (_cache[28] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Einbindung löschen", -1)
                                        ]))])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    (_unref(editForm).externalComponentTypeId == props.productGalleryTypeId)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createElementVNode("div", _hoisted_17, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "productGalleryContent",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(editForm).productGalleryContent) = $event)),
                                                    required: ""
                                                }, [...(_cache[29] || (_cache[29] = [
                                                        _createElementVNode("option", { value: "0" }, "Nach Kategorie", -1),
                                                        _createElementVNode("option", { value: "1" }, "Nach ausgewählten Produkten", -1)
                                                    ]))], 512), [
                                                    [_vModelSelect, _unref(editForm).productGalleryContent]
                                                ]),
                                                _cache[30] || (_cache[30] = _createElementVNode("label", { for: "productGalleryContent" }, "Galerie-Inhalt", -1))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_unref(editForm).productGalleryContent == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "productCategory",
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(editForm).productCategoryUuid) = $event)),
                                                required: ""
                                            }, [
                                                _cache[31] || (_cache[31] = _createElementVNode("option", { value: "0" }, "Keine Kategorie", -1)),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.productCategories, (category) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: category.uuid
                                                    }, _toDisplayString(category.name), 9, _hoisted_19));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(editForm).productCategoryUuid]
                                            ]),
                                            _cache[32] || (_cache[32] = _createElementVNode("label", { for: "productCategory" }, "Produkt-Kategorie", -1))
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_unref(editForm).productGalleryContent == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    _cache[33] || (_cache[33] = _createElementVNode("label", null, "Flaschen", -1)),
                                                    _createVNode(_unref(MultiSelect), {
                                                        class: "w-100",
                                                        modelValue: _unref(editForm).bottleUuids,
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(editForm).bottleUuids) = $event)),
                                                        options: props.bottles,
                                                        filter: "",
                                                        optionLabel: "name",
                                                        optionValue: "uuid",
                                                        placeholder: "Flaschen"
                                                    }, null, 8, ["modelValue", "options"])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _cache[34] || (_cache[34] = _createElementVNode("label", null, "Zubehör", -1)),
                                                    _createVNode(_unref(MultiSelect), {
                                                        class: "w-100",
                                                        modelValue: _unref(editForm).accessoryProductUuids,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(editForm).accessoryProductUuids) = $event)),
                                                        options: props.accessoryProducts,
                                                        filter: "",
                                                        optionLabel: "name",
                                                        optionValue: "uuid",
                                                        placeholder: "Zubehör"
                                                    }, null, 8, ["modelValue", "options"])
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            _cache[35] || (_cache[35] = _createElementVNode("h3", { class: "fw-bold" }, "Anleitung zur Einbindung", -1)),
                            _cache[36] || (_cache[36] = _createElementVNode("p", { class: "mb-4" }, "An gewünschter Stelle im Quell-Code folgendes IFrame-Fragment einbinden:", -1)),
                            _createElementVNode("h5", _hoisted_26, _toDisplayString(props.iframeComponent.iFrameFragment), 1),
                            _cache[37] || (_cache[37] = _createElementVNode("p", { class: "mb-4" }, "Folgendes Javascript-Fragment an das Ende des Quelltext vor dem schließenden html-Tag einbinden:", -1)),
                            _createElementVNode("h5", null, _toDisplayString(props.iframeComponent.jsCodeFragment), 1)
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
